import { Modal, Stack, Select, Textarea, Group, Button, Text } from "@mantine/core";
import { useState } from "react";

const UCC_STEP_OPTIONS = [
  // { value: "PAN_VERIFICATION", label: "PAN Verification" },
  { value: "PROFILE_DETAILS", label: "Other Details (FATCA + Address)" },
  { value: "NOMINEE_DETAILS", label: "Nominee Details (Nominee + Tax Details)" },
  { value: "BANK_VERIFICATION", label: "Bank Verification" },
];

interface ReassignUccModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: (step: string, note: string) => void | Promise<void>;
  isLoading?: boolean;
}

export default function ReassignUccModal({ opened, onClose, onConfirm, isLoading = false }: ReassignUccModalProps) {
  const [step, setStep] = useState<string | null>("PROFILE_DETAILS");
  const [note, setNote] = useState("");

  const handleConfirm = async () => {
    if (!step) return;
    await onConfirm(step, note);
  };

  const handleClose = () => {
    setStep("PROFILE_DETAILS");
    setNote("");
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title={
        <Text fw={600} size="lg">
          Update UCC
        </Text>
      }
      centered
      size="md"
    >
      <Stack gap="md">
        <Select
          label="Select step from which UCC needs to be updated"
          data={UCC_STEP_OPTIONS}
          value={step}
          onChange={setStep}
          allowDeselect={false}
        />

        <Textarea
          label="Add note to guide user"
          placeholder="Select note"
          minRows={4}
          maxRows={6}
          value={note}
          onChange={(e) => setNote(e.currentTarget.value)}
        />

        <Group justify="flex-end" mt="md">
          <Button color="primary.6" onClick={handleConfirm} loading={isLoading} disabled={!step}>
            Update
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
